import Carousel from "./components/Carousal";
import Carousel1 from "./components/Carousal2";
import Carousal3 from "./components/Carousal3";
import Layout from "./Layout";

const Gallery = () => {
    return (
        <Layout>
            <h1
                className="text-2xl mt-12 mb-4 text-center md:text-4xl font-bold text-[#0a1a42] font-roboto "
            >View Our Gallery</h1>
            <div className="mt-16">

                <h1
                    className="text-2xl mb-4 pb-4 text-center md:text-4xl font-bold text-[#0a1a42] font-roboto "
                >COBIS World Debate 2015 | Romania</h1>
                <Carousel />
            </div>


            <div className="pt-12 mt-16">
                <h1
                    className="text-2xl mb-4 pb-4 text-center md:text-4xl font-bold text-[#0a1a42] font-roboto "
                >Educational Trip to Mexico</h1>
                <div>
                    <Carousel1 />
                </div>
            </div>

            <div className="pt-12 mt-16">
                <h1
                    className="text-2xl mb-4 pb-4 text-center md:text-4xl font-bold text-[#0a1a42] font-roboto "
                >Educational Trip to the United Kingdom</h1>

                <Carousal3 />
                <div>

                </div>
            </div>

        </Layout>
    );
}

export default Gallery;